import { render, staticRenderFns } from "./NuovoOrdine.vue?vue&type=template&id=4d3ce225&scoped=true&"
import script from "./NuovoOrdine.vue?vue&type=script&lang=js&"
export * from "./NuovoOrdine.vue?vue&type=script&lang=js&"
import style0 from "./NuovoOrdine.vue?vue&type=style&index=0&id=4d3ce225&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3ce225",
  null
  
)

export default component.exports